import FileUploadFieldSet from './FileUploadFieldSet';

export default FileUploadFieldSet;
